import React, { useState } from "react";
import DataTable from "../../../components/AdminTable/DataTable";
import Dropdown from "../../../components/AdminDropdown/Dropdown";
import { Link } from "react-router-dom";

function Subscription() {
  const [showModal, setShowModal] = useState(false);

  const [columns] = useState([
    {
      header: "SN",
      accessorKey: "SN",
    },
    {
      header: "Heading",
      accessorKey: "Heading",
    },
    {
      header: "Details",
      accessorKey: "Details",
    },
    {
      header: "Service/Delivery Charge",
      accessorKey: "Charge",
    },
    {
      header: "Amount",
      accessorKey: "Amount",
    },
    {
      header: "Expire Days",
      accessorKey: "ExpireDays",
    },
    {
      header: "Actions",
      accessorKey: "SN",
      cell: (row) => <Dropdown />,
    },
  ]);

  const [data] = useState([
    {
      SN: 1,
      Heading: "Super Hot Deal",
      Details: "This is for testing purpose",
      Charge: "100",
      Amount: "500",
      ExpireDays: "25",
      Status: "active",
    },
    {
      SN: 2,
      Heading: "Super Hot Deal",
      Details: "This is only company employee",
      Charge: "100",
      Amount: "0",
      ExpireDays: "30",
      Status: "active",
    },
  ]);


  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="md:flex block flex-wrap justify-between">

          <div>

            <h1 className="text-[#7B20C7] text-2xl">Subscription</h1>
          </div>

          <div className="mb-2 ">

            <Link className="bg-[#7B20C7] text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
              type="button" onClick={() => setShowModal(true)}>Service/Delivery Charges</Link>

            <Link className="bg-[#7B20C7] text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit" to='./AddSubForm'
              type="button">Add Subscription</Link>
          </div>
        </div>




        <DataTable columns={columns} data={data}
        />
      </div>

      {showModal && (
        <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
          <div className="relative mx-auto w-1/3">
            {/*content*/}
            <div className="border-0 rounded-lg shadow-lg relative flex flex-col bg-white outline-none focus:outline-none overflow-y-auto shiftmodel">
              {/*header*/}
              <div className="flex items-start justify-center p-5 border-solid border-blueGray-200 rounded-t">
                <h1 className="text-xl text-[#7B20C7]">Service/Delivery Charge</h1>
                <button
                  className="ml-auto float-right text-2xl"
                  onClick={() => setShowModal(false)}
                >
                  <span className="text-[#7B20C7]"> × </span>
                </button>
              </div>
              <div className="px-4 text-[#7B20C7]">Delivery Amount *</div>
              <hr className="min-h-0.5 w-auto mx-2" />



              <div className="p-4">
                <input
                  type="text"
                  placeholder="Select Item"
                  className="placeholder-blueGray-300 text-blueGray-600 relative rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full p-2"
                  required
                />
              </div>

              <div className="flex items-center justify-end p-3">
                <button
                  className="text-[#7B20C7] text-md px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                  type="submit"
                  onClick={() => setShowModal(false)}
                >
                  Close
                </button>
                <button
                  className="bg-[#7B20C7] text-white text-md px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                  type="submit"
                >
                  Save Changes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showModal && (
        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
      )}
    </main>
  );
}

export default Subscription;
